fragment CenteredContentFragment on centeredContent_Entry {
  typeHandle
  heading
  body
  backgroundBlack
  cta {
    ...LinkFragment
  }
  icons {
    ... on centeredContentIconsBlock_Entry {
      id
      heading
      icon {
        url
      }
    }
  }
}
